import { defineComponent as _defineComponent } from 'vue'
import ExpansionPanel from '@/views/components/ExpansionPanel.vue';
import AlertCard from '@/views/components/AlertCard.vue';
import FiltroOrdenacao from '@/views/components/FiltroOrdenacao.vue';
import CardResultado from './CardResultado.vue';
import { ref } from 'vue';
import { mdiFilterVariant } from '@mdi/js';
import { usePublicoParecerReferencialStore } from '../store/PublicoParecerReferencialStore';
import { storeToRefs } from 'pinia';
import { contemNaLista, toggleSelecionado } from '@/utils/ListUtils';
import { isTodosSelecionados, selecionarTodos } from '@/utils/ListUtils';
import { mdiPrinter } from '@mdi/js';
import { Ordenacoes } from '../types';
import { OrdenacaoResponseDTO } from '@/types/common';


export default /*#__PURE__*/_defineComponent({
  __name: 'ResultadoConsulta',
  setup(__props) {

const store = usePublicoParecerReferencialStore();
const {
  filter,
  result,
  pareceresSelecionados,
  pagina,
  isImpressaoHabilitada,
  ordenacaoSelecionada,
} = storeToRefs(store);

const resultadoConsulta = ref<HTMLElement>();

const atualizarOrdenacao = async (ordenacao: OrdenacaoResponseDTO) => {
  ordenacaoSelecionada.value = ordenacao;
  filter.value.ordenacao = ordenacao.value as Ordenacoes;
  await store.consultar();
};

const atualizarPaginacao = async (page: number) => {
  filter.value.numPag = page - 1;
  await store.consultar();
  resultadoConsulta.value!.scrollIntoView({ behavior: 'smooth' });
};

const limparFiltrosResultado = () => {
  result.value?.subfiltros.forEach((filtro) =>
    filtro?.valoresSubFiltroResponseDTO?.forEach(
      (subFiltro) => (subFiltro.checked = false)
    )
  );
};

return { __sfc: true,store, filter, result, pareceresSelecionados, pagina, isImpressaoHabilitada, ordenacaoSelecionada, resultadoConsulta, atualizarOrdenacao, atualizarPaginacao, limparFiltrosResultado, ExpansionPanel, AlertCard, FiltroOrdenacao, CardResultado, mdiFilterVariant, contemNaLista, toggleSelecionado, isTodosSelecionados, selecionarTodos, mdiPrinter }
}

})